const EncodeRuleApi = require('./EncodeRule').default
export { EncodeRuleApi }



// WEBPACK FOOTER //
// ./src/services/EncodeRule/index.js